// const takeaway = require("../assets/images/superadmin/ordericon/takeaway.svg");
// const curbside = require("../assets/images/superadmin/ordericon/curb side.svg");
// const dinein = require("../assets/images/superadmin/ordericon/dine in.svg");
// const skiptheline = require("../assets/images/superadmin/ordericon/skip the line.svg");

const takeawayIcon = "https://iconslist.s3.amazonaws.com/Takeaway.svg";
const curbsideIcon = "https://iconslist.s3.amazonaws.com/curbside.svg";
const skipthelineIcon = "https://iconslist.s3.amazonaws.com/Skip_the_line.svg";
const dineinIcon = "https://iconslist.s3.amazonaws.com/Dine_in.svg";
const buffetIcon = require("../assets/images/Orders/Buffet.svg");
const cateringIcon = "https://iconslist.s3.amazonaws.com/catering.svg";
const driveThruIcon = require("../assets/images/Orders/Drive thru.svg");
const homeDeliveryIcon = "https://iconslist.s3.amazonaws.com/Delivery.svg";
const roomServiceIcon = "https://iconslist.s3.amazonaws.com/Room_Service.svg";
const atMySeat = "https://iconslist.s3.amazonaws.com/at_my_seat.svg";

export const expIcon = 'https://iconslist.s3.amazonaws.com/experience.png';

const INCASEOFUNAVAILABILITY = [
  "Contact me", //0
  "Cancel item", //1
  "Cancel order",
  "Substitute the item", //1
];

const DINE_IN_TOTAL_PAX = [
  { id: 0, value: 1 },
  { id: 1, value: 2 },
  { id: 2, value: 3 },
  { id: 3, value: 4 },
  { id: 4, value: 5 },
  { id: 5, value: 6 },
];

const ITEMTYPEVEG = [
  {
    id: 0,
    value: 1,
    title: "Veg",
    url: "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-190-0003.png",
  },
  {
    id: 1,
    value: 2,
    title: "Non Veg",
    // url: "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-190-0002.png",
    url: "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-Non Veg.png",
  },
  {
    id: 2,
    value: 3,
    title: "Egg",
    url: "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-190-0001.png",
  },
];

const DELIVERY_TYPES = [
  {
    id: "INDEPENDENT",
    title: "Indepdent House",
    icon: require("../assets/images/superadmin/ordericon/house.svg"),
  },
  {
    id: "HIGHRISE",
    title: "HighRise",
    icon: require("../assets/images/superadmin/ordericon/HighRise.svg"),
  },
  {
    id: "COMMUNITY",
    title: "Community",
    icon: require("../assets/images/superadmin/ordericon/Community.svg"),
  },
  {
    id: "GATED",
    title: "Gated",
    icon: require("../assets/images/superadmin/ordericon/gated.svg"),
  },
];

const CAR_COLORS = [
  { name: "White", value: "#FFFFFF" },
  { name: "Silver", value: "#C0C0C0" },
  { name: "Black", value: "#000000" },
  { name: "Gray", value: "#808080" },
  { name: "Blue", value: "#0000FF" },
  { name: "Red", value: "#FF0000" },
  { name: "Brown", value: "#964B00" },
  { name: "Green", value: "#00FF00" },
  { name: "Yellow", value: "#FFFF00" },
  { name: "Beige", value: "#F5F5DC" },
  { name: "Gold", value: "#FFD700" },
  { name: "Orange", value: "#FFA500" },
  { name: "Purple", value: "#800080" },
];
const REFERRAL_PROGRAM_TYPES = [
  { name: "user to user Referral", value: "UU" },
  { name: "user to merchant Referral", value: "UV" },
  { name: "merchant to user Referral", value: "VU" },
  { name: "Marketing and promotion to User Referral", value: "VV" },
  { name: "Sales rep to Merchant Referral", value: "AU" },
  { name: "ffiliate to User Referral", value: "SV" },
  { name: "Affiliates to Merchant Referral", value: "SU" },
  { name: "Partner to User  Referral", value: "PU" },
  { name: "Partner to Merchant Referral", value: "MU" },
];

const ORDER_STATUS = [
  "PENDING", //0
  "CONFIRMED", //1
  "PREPARING", //2
  "PACKING", //3
  "READYTOPICK", //4
  "ONTHEWAY", //5
  "DELIVERED", //6
  "COMPLETED", //7
  "CANCELLED", //8
  "",
  "RETURNED"
];

const REFERRAL_TYPE = [
  "user to user",
  "user to merchant",
  "merchant to user",
  "merchant to merchant",
];

const ORDER_TYPE = [
  "TAKEAWAY",
  "CURBSIDE",
  "SKIPTHELINE",
  "DINEIN",
  "BUFFET",
  "CATERING",
  "DRIVETHRU",
  "HOMEDELIVERY",
];
const ORDER_TYPESS = [
  { title: "All", value: "All" },
  { title: "TAKEAWAY", value: 0 },
  { title: "CURBSIDE", value: 1 },
  { title: "BUFFET", value: 2 },
  { title: "DINEIN", value: 3 },
  { title: "CATERING", value: 4 },
  { title: "DRIVETHRU", value: 5 },
  { title: "HOMEDELIVERY", value: 6 },
  { title: "SKIPTHELINE", value: 7 },
];
const EVENT_TYPE = ["Offline", "Online"];
const EXP_TYPE = ["CURATED", "SPECIAL"];

const ORDER_TYPE_NAME = [
  "Takeaway",
  "Curbside",
  "Skip the Line",
  "Dine-In",
  "Buffet",
  "Catering",
  "Drivethru",
  "Delivery",
];

const ORDER_ICONS = [
  takeawayIcon,
  curbsideIcon,
  skipthelineIcon,
  dineinIcon,
  buffetIcon,
  cateringIcon,
  driveThruIcon,
  homeDeliveryIcon,
];

const PAYMENT_TYPE = [
  "CASH",
  "UPI",
  "PAYTM",
  "DEBITCARD",
  "CREDITCARD",
  "NETBANKING",
  "PAYLATER",
  "WALLET",
];
const NEW_PAYMENT_TYPE = [
  "COD",
  "UPI",
  "Paytm",
  "Debit Card",
  "Credit Card",
  "NetBanking",
  "Pay Later",
  "Wallet",
  "External Wallet",
  "Cash",
];
const PAYMENT_TYPE_FILTER = [
  { id: 0, value: 10, title: "All" },
  //  { id: 1, value: 0, title: "COD" },
  { id: 2, value: 1, title: "UPI" },
  { id: 3, value: 2, title: "PAYTM" },
  { id: 4, value: 3, title: "DEBITCARD" },
  { id: 5, value: 4, title: "CREDITCARD" },
  { id: 6, value: 5, title: "NETBANKING" },
  { id: 7, value: 6, title: "PAYLATER" },
  { id: 8, value: 7, title: "WALLET" },
  { id: 9, value: 8, title: "EXTERNAL WALLET" },
  { id: 10, value: 9, title: "CASH" },
  { id: 11, value: 11, title: "SPLIT PAYMENT" },
];

const PAYMENT_STATUS = [
  "PENDING",
  "SUCCESS",
  "CANCELLED",
  "FAILURE",
  "REVERSED",
];

const FLAT_CHARGE_KEYS = [
  "take_away",
  "curb_side",
  "skip_line",
  "dine_in_order",
  "buffet",
  "catering_banquet",
  "drive_thru",
  "home_delivery",
];

const ORDER_TYPES = [
  "take_away",
  "curb_side",
  "skip_line",
  "dine_in",
  "buffet",
  "catering_banquet",
  "drive_thru",
  "home_delivery",
];

const PAYMENT_METHOD_STATUS = ["UNPAID", "PAID", "N/A", "FAILURE"];

const ORDER_TYPE_FILTER = [
  { id: 0, value: 10, title: "All", ref: "" },
  { id: 1, value: 0, title: "TAKEAWAY", ref: "take_away" },
  { id: 2, value: 1, title: "CURBSIDE", ref: "cubside_delivery" },
  { id: 3, value: 2, title: "SKIPTHELINE", ref: "self_serve" },
  { id: 4, value: 3, title: "DINEIN", ref: "dine_in_order" },
  { id: 5, value: 4, title: "DELIVERY", ref: "home_delivery" },
];

const EXPERIENCE_STATUS_FILTER = [
  { id: 0, value: "PENDING", title: "PENDING" },
  { id: 1, value: "NOTSEATED", title: "NOTSEATED" },
  { id: 2, value: "SEATED", title: "SEATED" },
  { id: 3, value: "REJECTED", title: "REJECTED" },
  { id: 4, value: "COMPLETED", title: "COMPLETED" },
  { id: 5, value: "CANCELLED", title: "CANCELLED" },
];
const PAYMENT_METHOD_STATUS_FILTER = [
  { id: 0, value: 10, title: "All" },
  { id: 1, value: 0, title: "UNPAID" },
  { id: 2, value: 1, title: "PAID" },
  { id: 3, value: 2, title: "N/A" },
  { id: 4, value: 3, title: "FAILURE" },
];

const TRANSACTION_TYPE = [
  "CREDIT MEMO",
  "DEBIT MEMO",
  "PAID",
  "TRANSFERRED",
  "REFUND AND CANCELLATION",
  "WITHDRAWAL",
  "MONEY ADDED TO WALLET",
  "MONEY DEBITED FROM WALLET",
  "CASHBACK",
  "RECEIVED",
  "DONATION",
];

const SPICELEVEL = [
  { id: 0, value: 0, title: "No Spice" },
  { id: 1, value: 1, title: "Mild" },
  { id: 2, value: 2, title: "Medium" },
  { id: 3, value: 3, title: "Hot" },
  { id: 4, value: 4, title: "Very Hot" },
];
const SALTLEVEL = [
  { id: 0, value: 0, title: "No Salt" },
  { id: 1, value: 1, title: "Low" },
  { id: 2, value: 2, title: "Normal" },
  { id: 3, value: 3, title: "Medium" },
  { id: 4, value: 4, title: "Salty" },
  { id: 5, value: 5, title: "Very Salty" },
];
const SUGARLEVEL = [
  { id: 0, value: 0, title: "No Sugar" },
  { id: 1, value: 1, title: "Low" },
  { id: 2, value: 2, title: "Normal" },
  { id: 3, value: 3, title: "Medium" },
  { id: 4, value: 4, title: "Sweet" },
  { id: 5, value: 5, title: "Very Sweet" },
];
const FATLEVEL = [
  { id: 0, value: 0, title: "No Oil" },
  { id: 1, value: 1, title: "Low" },
  { id: 2, value: 2, title: "Normal" },
  { id: 3, value: 3, title: "Medium" },
  { id: 4, value: 4, title: "Regular" },
  { id: 5, value: 5, title: "Extra" },
];
const MEATCOOKLEVEL = [
  { id: 0, value: 0, title: "Raw" },
  { id: 1, value: 1, title: "Rare" },
  { id: 2, value: 2, title: "Medium Rare" },
  { id: 3, value: 3, title: "Medium" },
  { id: 4, value: 4, title: "Regular" },
  { id: 5, value: 5, title: "Well Done" },
];
const EGGCOOKLEVEL = [
  { id: 0, value: 0, title: "Raw" },
  { id: 1, value: 1, title: "Boiled" },
  { id: 2, value: 2, title: "Sunny Side Up" },
  { id: 3, value: 3, title: "Scrambled" },
  { id: 4, value: 4, title: "Omelette" },
  { id: 5, value: 5, title: "Well Done" },
];

const ALL_ORDER_STATUS = [
  {
    id: 10,
    title: "All",
    value: "All",
    orderType: 10,
    clickAction: () => { },
  },
  {
    id: 1,
    title: "Accepted Order",
    value: "Accepted Order",
    orderType: 10,
    clickAction: () => { },
  },
  {
    id: 2,
    title: "Getting Prepared",
    value: "Getting Prepared",
    orderType: 10,
    clickAction: () => { },
  },
  {
    id: 4,
    title: "Ready for Take Away",
    value: "Ready for Take Away",
    orderType: 0,
    clickAction: () => { },
  },
  {
    id: 4,
    title: "Ready for Curbside",
    value: "Ready for Curbside",
    orderType: 1,
    clickAction: () => { },
  },
  {
    id: 4,
    title: "Ready for Delivery",
    value: "Ready for Delivery",
    orderType: 7,
    clickAction: () => { },
  },
  {
    id: 4,
    title: "Ready for Dine-in",
    value: "Ready for Dine-in",
    orderType: 3,
    clickAction: () => { },
  },
  {
    id: 4,
    title: "Ready for Pickup",
    value: "Ready for Pickup",
    orderType: 2,
    clickAction: () => { },
  },
  {
    id: 3,
    title: "Food Packing",
    value: "Food Packing",
    orderType: 10,
    clickAction: () => { },
  },
  {
    id: 3,
    title: "Food Plating",
    value: "Food Plating",
    orderType: 3,
    clickAction: () => { },
  },
  {
    id: 6,
    title: "Served",
    value: "Served",
    orderType: 3,
    clickAction: () => { },
  },
  {
    id: 6,
    title: "Delivered",
    value: "Delivered",
    orderType: 10,
    clickAction: () => { },
  },
];

const HISTORY_ORDER_STATUS = [
  { id: 10, title: "All", value: "All", clickAction: () => { } },
  { id: 7, title: "Completed", value: "Completed", clickAction: () => { } },
  { id: 8, title: "Cancelled", value: "Cancelled", clickAction: () => { } },
];

const PENDING_ORDER_STATUS = [
  { id: 10, title: "All", value: "All", clickAction: () => { } },
  // {
  //   id: 0,
  //   title: "Order Request",
  //   value: "Order Request",
  //   clickAction: () => {},
  // },
];

const TAKEAWAY_ORDER_STATUS = [
  { id: 10, title: "All", value: "All", clickAction: () => { } },
  {
    id: 1,
    title: "Accepted Order",
    value: "Accepted Order",
    clickAction: () => { },
  },
  {
    id: 2,
    title: "Getting Prepared",
    value: "Getting Prepared",
    clickAction: () => { },
  },
  {
    id: 3,
    title: "Food Packing",
    value: "Food Packing",
    clickAction: () => { },
  },
  {
    id: 4,
    title: "Ready for Take Away",
    value: "Ready for Take Away",
    clickAction: () => { },
  },
  { id: 6, title: "Delivered", value: "Delivered", clickAction: () => { } },
  // { id: 7, title: "Completed", value: "Completed", clickAction: () => {} },
];

const CURBSIDE_ORDER_STATUS = [
  { id: 10, title: "All", value: "All", clickAction: () => { } },
  {
    id: 1,
    title: "Accepted Order",
    value: "Accepted Order",
    clickAction: () => { },
  },
  {
    id: 2,
    title: "Getting Prepared",
    value: "Getting Prepared",
    clickAction: () => { },
  },
  {
    id: 3,
    title: "Food Packing",
    value: "Food Packing",
    clickAction: () => { },
  },
  {
    id: 4,
    title: "Ready for Curbside",
    value: "Ready for Curbside",
    clickAction: () => { },
  },
  { id: 6, title: "Delivered", value: "Delivered", clickAction: () => { } },
  // { id: 7, title: "Completed", value: "Completed", clickAction: () => {} },
];

const DINE_In_ORDER_STATUS = [
  { id: 10, title: "All", value: "All", clickAction: () => { } },
  {
    id: 1,
    title: "Accepted Order",
    value: "Accepted Order",
    clickAction: () => { },
  },
  {
    id: 2,
    title: "Getting Prepared",
    value: "Getting Prepared",
    clickAction: () => { },
  },
  {
    id: 3,
    title: "Food Plating",
    value: "Food Plating",
    clickAction: () => { },
  },
  {
    id: 4,
    title: "Ready for Dine-in",
    value: "Ready for Dine-in",
    clickAction: () => { },
  },
  { id: 6, title: "Served", value: "Served", clickAction: () => { } },
  // { id: 7, title: "Completed", value: "Completed", clickAction: () => {} },
];

const SKIP_THE_LINE_ORDER_STATUS = [
  { id: 10, title: "All", value: "All", clickAction: () => { } },
  {
    id: 1,
    title: "Accepted Order",
    value: "Accepted Order",
    clickAction: () => { },
  },
  {
    id: 2,
    title: "Getting Prepared",
    value: "Getting Prepared",
    clickAction: () => { },
  },
  {
    id: 3,
    title: "Food Packing",
    value: "Food Packing",
    clickAction: () => { },
  },
  {
    id: 4,
    title: "Ready for Pickup",
    value: "Ready for Pickup",
    clickAction: () => { },
  },
  { id: 6, title: "Delivered", value: "Delivered", clickAction: () => { } },
  // { id: 7, title: "Completed", value: "Completed", clickAction: () => {} },
];

const DELIVERY_ORDER_STATUS = [
  { id: 10, title: "All", value: "All", clickAction: () => { } },
  {
    id: 1,
    title: "Accepted Order",
    value: "Accepted Order",
    clickAction: () => { },
  },
  {
    id: 2,
    title: "Getting Prepared",
    value: "Getting Prepared",
    clickAction: () => { },
  },
  {
    id: 3,
    title: "Food Packing",
    value: "Food Packing",
    clickAction: () => { },
  },
  {
    id: 4,
    title: "Ready for Delivery",
    value: "Ready for Delivery",
    clickAction: () => { },
  },
  { id: 6, title: "Delivered", value: "Delivered", clickAction: () => { } },
  // { id: 7, title: "Completed", value: "Completed", clickAction: () => {} },
];

export {
  INCASEOFUNAVAILABILITY,
  DINE_IN_TOTAL_PAX,
  ITEMTYPEVEG,
  CAR_COLORS,
  ORDER_STATUS,
  ORDER_TYPE,
  ORDER_TYPESS,
  PAYMENT_TYPE,
  PAYMENT_STATUS,
  NEW_PAYMENT_TYPE,
  PAYMENT_METHOD_STATUS,
  ORDER_TYPE_FILTER,
  PAYMENT_TYPE_FILTER,
  PAYMENT_METHOD_STATUS_FILTER,
  EXPERIENCE_STATUS_FILTER,
  ORDER_TYPE_NAME,
  EVENT_TYPE,
  EXP_TYPE,
  ORDER_ICONS,
  TRANSACTION_TYPE,
  FLAT_CHARGE_KEYS,
  SPICELEVEL,
  SALTLEVEL,
  SUGARLEVEL,
  FATLEVEL,
  MEATCOOKLEVEL,
  EGGCOOKLEVEL,
  DELIVERY_TYPES,
  REFERRAL_TYPE,
  ORDER_TYPES,
  PENDING_ORDER_STATUS,
  ALL_ORDER_STATUS,
  HISTORY_ORDER_STATUS,
  TAKEAWAY_ORDER_STATUS,
  CURBSIDE_ORDER_STATUS,
  DINE_In_ORDER_STATUS,
  SKIP_THE_LINE_ORDER_STATUS,
  DELIVERY_ORDER_STATUS,
  REFERRAL_PROGRAM_TYPES
};
